/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: ubeda7DFXIoq
import * as React from "react";
import {
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import * as plasmicAuth from "@plasmicapp/react-web/lib/auth";
import { usePlasmicDataSourceContext } from "@plasmicapp/data-sources-context";
import AppShell from "../../AppShell"; // plasmic-import: Vh273IDurq9t/component
import WebTab from "../../WebTab"; // plasmic-import: XNSjqwwbHvXu/component
import WebTopNav from "../../WebTopNav"; // plasmic-import: tGgk6oqzsXGR/component
import Breadcrumb from "../../Breadcrumb"; // plasmic-import: k0sjE64BjPfV/component
import ButtonSecondary from "../../ButtonSecondary"; // plasmic-import: yzRkzInaRral/component
import ContainerInTab from "../../ContainerInTab"; // plasmic-import: _lT-Lq7an5i5/component
import WebSupportContainer from "../../WebSupportContainer"; // plasmic-import: WgkFi0SpEFe_/component
import InputFormShell from "../../InputFormShell"; // plasmic-import: mqAYXqPyOASe/component
import FormElement from "../../FormElement"; // plasmic-import: ncxDEJ0p8q40/component
import InputFieldUnderline from "../../InputFieldUnderline"; // plasmic-import: BftYWjxj5zbk/component
import Textarea from "../../Textarea"; // plasmic-import: mONk3pvEmt2Y/component
import WebDock from "../../WebDock"; // plasmic-import: EtVLWfl2KEmA/component
import ButtonDock from "../../ButtonDock"; // plasmic-import: utQE8oqBBjiK/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicWebSupport.module.css"; // plasmic-import: ubeda7DFXIoq/css
import Icon30Icon from "./icons/PlasmicIcon__Icon30"; // plasmic-import: v-1PLPXOc6tO/icon
import Icon23Icon from "./icons/PlasmicIcon__Icon23"; // plasmic-import: YwlgzG5yARIP/icon
import Icon34Icon from "./icons/PlasmicIcon__Icon34"; // plasmic-import: 3VA-qZnm8pUB/icon
import Icon32Icon from "./icons/PlasmicIcon__Icon32"; // plasmic-import: dWHMt3F1tCmW/icon
import Icon33Icon from "./icons/PlasmicIcon__Icon33"; // plasmic-import: h408FMoSv0qx/icon
import Icon15Icon from "./icons/PlasmicIcon__Icon15"; // plasmic-import: KZeS8_m5UsgE/icon
import Icon27Icon from "./icons/PlasmicIcon__Icon27"; // plasmic-import: WzMsUn33Iqfb/icon
import Icon26Icon from "./icons/PlasmicIcon__Icon26"; // plasmic-import: flPWDcL8BgpD/icon

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    title: "o21p support.",
    openGraph: {
      title: "o21p support."
    },
    twitter: {
      card: "summary",
      title: "o21p support."
    }
  };
}

createPlasmicElementProxy;

export const PlasmicWebSupport__VariantProps = new Array();

export const PlasmicWebSupport__ArgProps = new Array();

const $$ = {};

function PlasmicWebSupport__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "isFormSubmited",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "helperText",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      },
      {
        path: "helperTextOn",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "showErrorMode",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => "normal"
      },
      {
        path: "errorExist",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => true
      },
      {
        path: "nameValue",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      },
      {
        path: "nameStatus",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => "normal"
      },
      {
        path: "textAreaStatus",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => "normal"
      },
      {
        path: "emailStatus",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => "normal"
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames,
          sty.root
        )}
      >
        <AppShell
          data-plasmic-name={"appShell"}
          data-plasmic-override={overrides.appShell}
          appShell={
            <WebTab
              data-plasmic-name={"webTab"}
              data-plasmic-override={overrides.webTab}
              className={classNames("__wab_instance", sty.webTab)}
              tabContent={
                <ContainerInTab
                  data-plasmic-name={"containerInTab"}
                  data-plasmic-override={overrides.containerInTab}
                  bgColor={"light"}
                  padding={"global"}
                >
                  <WebSupportContainer
                    data-plasmic-name={"webSupportContainer"}
                    data-plasmic-override={overrides.webSupportContainer}
                    className={classNames(
                      "__wab_instance",
                      sty.webSupportContainer
                    )}
                    status={"_default"}
                    textareaWrapp4={
                      <Textarea
                        className={classNames(
                          "__wab_instance",
                          sty.textarea__r5Epa
                        )}
                        flexibleLayout={"bigHeight"}
                        id={"messageTextArea"}
                        inputName={"inquirerMessage"}
                        placeholder={
                          "Alright, we\u2019re on it. Do you need help with anything else?"
                        }
                        radius={"halfModule"}
                        required={true}
                      />
                    }
                    theFormGoesHere={
                      <InputFormShell
                        data-plasmic-name={"inputFormShell"}
                        data-plasmic-override={overrides.inputFormShell}
                        className={classNames(
                          "__wab_instance",
                          sty.inputFormShell
                        )}
                        fieldsSlot={
                          <FormElement
                            data-plasmic-name={"formElement"}
                            data-plasmic-override={overrides.formElement}
                            className={classNames(
                              "__wab_instance",
                              sty.formElement
                            )}
                            formInputComponent={
                              <div
                                data-plasmic-name={"supportFormWrapper"}
                                data-plasmic-override={
                                  overrides.supportFormWrapper
                                }
                                className={classNames(
                                  projectcss.all,
                                  sty.supportFormWrapper
                                )}
                              >
                                <div
                                  data-plasmic-name={"floatyWrapper5"}
                                  data-plasmic-override={
                                    overrides.floatyWrapper5
                                  }
                                  className={classNames(
                                    projectcss.all,
                                    sty.floatyWrapper5
                                  )}
                                >
                                  <div
                                    data-plasmic-name={"inlineTextWrapp6"}
                                    data-plasmic-override={
                                      overrides.inlineTextWrapp6
                                    }
                                    className={classNames(
                                      projectcss.all,
                                      sty.inlineTextWrapp6
                                    )}
                                  >
                                    <div
                                      className={classNames(
                                        projectcss.all,
                                        projectcss.__wab_text,
                                        sty.text__noBh4
                                      )}
                                    >
                                      {"I'm"}
                                    </div>
                                  </div>
                                  <InputFieldUnderline
                                    className={classNames(
                                      "__wab_instance",
                                      sty.inputFieldUnderline___7Udqz
                                    )}
                                    id={"iAmId"}
                                    inputName={"inquirerName"}
                                    onClick={async () => {
                                      const $steps = {};
                                      $steps["runCode"] = true
                                        ? (() => {
                                            const actionArgs = {
                                              customFunction: async () => {
                                                return (() => {
                                                  if (
                                                    $state.nameStatus ===
                                                    "error"
                                                  ) {
                                                    const nameInput =
                                                      document.getElementById(
                                                        "iAmId"
                                                      );
                                                    const name =
                                                      nameInput.value;
                                                    $state.nameStatus =
                                                      "normal";
                                                    return (nameInput.value =
                                                      "");
                                                  }
                                                })();
                                              }
                                            };
                                            return (({ customFunction }) => {
                                              return customFunction();
                                            })?.apply(null, [actionArgs]);
                                          })()
                                        : undefined;
                                      if (
                                        $steps["runCode"] != null &&
                                        typeof $steps["runCode"] === "object" &&
                                        typeof $steps["runCode"].then ===
                                          "function"
                                      ) {
                                        $steps["runCode"] =
                                          await $steps["runCode"];
                                      }
                                    }}
                                    onSurface={"onGrey"}
                                    padding={"noPadding"}
                                    placeholder={'"John Smith"'}
                                    required={true}
                                    status={(() => {
                                      try {
                                        return $state.nameStatus;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return "normal";
                                        }
                                        throw e;
                                      }
                                    })()}
                                    type={"text"}
                                    value={``}
                                  />
                                </div>
                                <div
                                  className={classNames(
                                    projectcss.all,
                                    sty.freeBox___6Lcuc
                                  )}
                                >
                                  <div
                                    className={classNames(
                                      projectcss.all,
                                      sty.freeBox__jxyHg
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"textareaWrapp2"}
                                      data-plasmic-override={
                                        overrides.textareaWrapp2
                                      }
                                      className={classNames(
                                        projectcss.all,
                                        sty.textareaWrapp2
                                      )}
                                    >
                                      <Textarea
                                        className={classNames(
                                          "__wab_instance",
                                          sty.textarea__ieyP
                                        )}
                                        flexibleLayout={"bigHeight"}
                                        id={"messageTextArea"}
                                        inputName={"inquirerMessage"}
                                        onClick={async () => {
                                          const $steps = {};
                                          $steps["runCode"] = true
                                            ? (() => {
                                                const actionArgs = {
                                                  customFunction: async () => {
                                                    return (() => {
                                                      if (
                                                        $state.textAreaStatus ===
                                                        "error"
                                                      ) {
                                                        const messageInput =
                                                          document.getElementById(
                                                            "messageTextArea"
                                                          );
                                                        const message =
                                                          messageInput.value;
                                                        $state.textAreaStatus =
                                                          "normal";
                                                        return (messageInput.value =
                                                          "");
                                                      }
                                                    })();
                                                  }
                                                };
                                                return (({
                                                  customFunction
                                                }) => {
                                                  return customFunction();
                                                })?.apply(null, [actionArgs]);
                                              })()
                                            : undefined;
                                          if (
                                            $steps["runCode"] != null &&
                                            typeof $steps["runCode"] ===
                                              "object" &&
                                            typeof $steps["runCode"].then ===
                                              "function"
                                          ) {
                                            $steps["runCode"] =
                                              await $steps["runCode"];
                                          }
                                        }}
                                        placeholder={"message..."}
                                        radius={"halfModule"}
                                        required={true}
                                        status={(() => {
                                          try {
                                            return $state.textAreaStatus;
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return "normal";
                                            }
                                            throw e;
                                          }
                                        })()}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-plasmic-name={"floatyWrapper6"}
                                  data-plasmic-override={
                                    overrides.floatyWrapper6
                                  }
                                  className={classNames(
                                    projectcss.all,
                                    sty.floatyWrapper6
                                  )}
                                >
                                  <div
                                    className={classNames(
                                      projectcss.all,
                                      sty.freeBox__c8Vxu
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"inlineTextWrapp7"}
                                      data-plasmic-override={
                                        overrides.inlineTextWrapp7
                                      }
                                      className={classNames(
                                        projectcss.all,
                                        sty.inlineTextWrapp7
                                      )}
                                    >
                                      <div
                                        className={classNames(
                                          projectcss.all,
                                          projectcss.__wab_text,
                                          sty.text__sIab8
                                        )}
                                      >
                                        {
                                          "and I\u2019d like to continue this conversation at\r"
                                        }
                                      </div>
                                    </div>
                                    <InputFieldUnderline
                                      className={classNames(
                                        "__wab_instance",
                                        sty.inputFieldUnderline__jfKrn
                                      )}
                                      id={"emailInput"}
                                      inputName={"inquirerEmail"}
                                      onSurface={"onGrey"}
                                      padding={"noPadding"}
                                      placeholder={'"email@example.com"'}
                                      required={true}
                                      status={(() => {
                                        try {
                                          return $state.emailStatus;
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return [];
                                          }
                                          throw e;
                                        }
                                      })()}
                                      type={"email"}
                                    />
                                  </div>
                                  <div
                                    data-plasmic-name={"inlineTextWrapp8"}
                                    data-plasmic-override={
                                      overrides.inlineTextWrapp8
                                    }
                                    className={classNames(
                                      projectcss.all,
                                      sty.inlineTextWrapp8
                                    )}
                                  >
                                    <div
                                      className={classNames(
                                        projectcss.all,
                                        projectcss.__wab_text,
                                        sty.text__p2Ro
                                      )}
                                    >
                                      <React.Fragment>
                                        <React.Fragment>{"[ "}</React.Fragment>
                                        {
                                          <PlasmicLink__
                                            className={classNames(
                                              projectcss.all,
                                              projectcss.a,
                                              projectcss.a__fRuRb,
                                              projectcss.__wab_text,
                                              projectcss.plasmic_default__inline,
                                              sty.link__wiSrb
                                            )}
                                            name={"webInqSendButton"}
                                            onClick={async event => {
                                              const $steps = {};
                                              $steps["checks"] = true
                                                ? (() => {
                                                    const actionArgs = {
                                                      customFunction:
                                                        async () => {
                                                          return (() => {
                                                            console.log(
                                                              "Butonul funcționează"
                                                            );
                                                            let name = document
                                                              .getElementById(
                                                                "iAmId"
                                                              )
                                                              .value.trim();
                                                            let message =
                                                              document
                                                                .getElementById(
                                                                  "messageTextArea"
                                                                )
                                                                .value.trim();
                                                            let email = document
                                                              .getElementById(
                                                                "emailInput"
                                                              )
                                                              .value.trim();
                                                            console.log(
                                                              "name:",
                                                              name,
                                                              "message:",
                                                              message,
                                                              "email:",
                                                              email
                                                            );
                                                            let errors = [];
                                                            if (name === "") {
                                                              errors.push(
                                                                "Please fill this required field"
                                                              );
                                                              console.error(
                                                                "\u274C Validation errors:",
                                                                errors.join(
                                                                  ", "
                                                                )
                                                              );
                                                              console.log(
                                                                "Please fix the following:\n" +
                                                                  errors.join(
                                                                    "\n"
                                                                  )
                                                              );
                                                              $state.showErrorMode =
                                                                "error";
                                                              $state.helperTextOn = true;
                                                              $state.helperText =
                                                                errors.join(
                                                                  ", "
                                                                );
                                                              $state.errorExist = true;
                                                              $state.isFormSubmited = false;
                                                              $state.nameStatus =
                                                                "error";
                                                            }
                                                            if (
                                                              message === "" &&
                                                              name !== ""
                                                            ) {
                                                              errors.push(
                                                                "Please fill this required field"
                                                              );
                                                              console.error(
                                                                "\u274C Validation errors:",
                                                                errors.join(
                                                                  ", "
                                                                )
                                                              );
                                                              console.log(
                                                                "Please fix the following:\n" +
                                                                  errors.join(
                                                                    "\n"
                                                                  )
                                                              );
                                                              $state.showErrorMode =
                                                                "error";
                                                              $state.helperTextOn = true;
                                                              $state.helperText =
                                                                errors.join(
                                                                  ", "
                                                                );
                                                              $state.errorExist = true;
                                                              $state.isFormSubmited = false;
                                                              $state.nameStatus =
                                                                "normal";
                                                              $state.textAreaStatus =
                                                                "error";
                                                            }
                                                            if (
                                                              email === "" &&
                                                              message !== ""
                                                            ) {
                                                              errors.push(
                                                                "Please fill this required field"
                                                              );
                                                              console.error(
                                                                "\u274C Validation errors:",
                                                                errors.join(
                                                                  ", "
                                                                )
                                                              );
                                                              console.log(
                                                                "Please fix the following:\n" +
                                                                  errors.join(
                                                                    "\n"
                                                                  )
                                                              );
                                                              $state.showErrorMode =
                                                                "error";
                                                              $state.helperTextOn = true;
                                                              $state.helperText =
                                                                errors.join(
                                                                  ", "
                                                                );
                                                              $state.errorExist = true;
                                                              $state.isFormSubmited = false;
                                                              $state.nameStatus =
                                                                "normal";
                                                              $state.textAreaStatus =
                                                                "normal";
                                                              $state.emailStatus =
                                                                "error";
                                                            } else if (
                                                              email !== ""
                                                            ) {
                                                              const emailPattern =
                                                                /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                                              if (
                                                                !emailPattern.test(
                                                                  email
                                                                )
                                                              ) {
                                                                errors.push(
                                                                  "Invalid email format"
                                                                );
                                                              }
                                                              console.error(
                                                                "\u274C Validation errors:",
                                                                errors.join(
                                                                  ", "
                                                                )
                                                              );
                                                              console.log(
                                                                "Please fix the following:\n" +
                                                                  errors.join(
                                                                    "\n"
                                                                  )
                                                              );
                                                              $state.showErrorMode =
                                                                "error";
                                                              $state.helperTextOn = true;
                                                              $state.helperText =
                                                                errors.join(
                                                                  ", "
                                                                );
                                                              $state.errorExist = true;
                                                              $state.isFormSubmited = false;
                                                              $state.nameStatus =
                                                                "normal";
                                                              $state.textAreaStatus =
                                                                "normal";
                                                              $state.emailStatus =
                                                                "error";
                                                            }
                                                            if (
                                                              errors.length > 0
                                                            ) {
                                                              console.error(
                                                                "\u274C Validation errors:",
                                                                errors.join(
                                                                  ", "
                                                                )
                                                              );
                                                              console.log(
                                                                "Please fix the following:\n" +
                                                                  errors.join(
                                                                    "\n"
                                                                  )
                                                              );
                                                            } else {
                                                              console.log(
                                                                "\u2705 All fields are valid"
                                                              );
                                                              $state.errorExist = false;
                                                              $state.helperTextOn = false;
                                                              $state.isFormSubmited = true;
                                                              $state.nameStatus =
                                                                "normal";
                                                              $state.textAreaStatus =
                                                                "normal";
                                                              $state.emailStatus =
                                                                "normal";
                                                            }
                                                            if (name === "") {
                                                              $state.nameStatus =
                                                                "error";
                                                            }
                                                            if (
                                                              message === ""
                                                            ) {
                                                              $state.textAreaStatus =
                                                                "error";
                                                            }
                                                            if (email === "") {
                                                              $state.emailStatus =
                                                                "error";
                                                            }
                                                            email = "";
                                                            name = "";
                                                            return (message =
                                                              "");
                                                          })();
                                                        }
                                                    };
                                                    return (({
                                                      customFunction
                                                    }) => {
                                                      return customFunction();
                                                    })?.apply(null, [
                                                      actionArgs
                                                    ]);
                                                  })()
                                                : undefined;
                                              if (
                                                $steps["checks"] != null &&
                                                typeof $steps["checks"] ===
                                                  "object" &&
                                                typeof $steps["checks"].then ===
                                                  "function"
                                              ) {
                                                $steps["checks"] =
                                                  await $steps["checks"];
                                              }
                                              $steps["backend"] = true
                                                ? (() => {
                                                    const actionArgs = {
                                                      customFunction:
                                                        async () => {
                                                          return (async () => {
                                                            const nameInput =
                                                              document.getElementById(
                                                                "iAmId"
                                                              );
                                                            const name =
                                                              nameInput.value;
                                                            const messageInput =
                                                              document.getElementById(
                                                                "messageTextArea"
                                                              );
                                                            const message =
                                                              messageInput.value;
                                                            var emailInput =
                                                              document.getElementById(
                                                                "emailInput"
                                                              );
                                                            var email =
                                                              emailInput.value;
                                                            console.log(
                                                              "email email: ",
                                                              email
                                                            );
                                                            const payload = {
                                                              name: name,
                                                              message: message,
                                                              email: email
                                                            };
                                                            console.log(
                                                              "Sending payload:",
                                                              payload
                                                            );
                                                            if (
                                                              $state.errorExist ===
                                                              false
                                                            ) {
                                                              return fetch(
                                                                "https://opformypractice.com/api/plasmic-support/",
                                                                {
                                                                  method:
                                                                    "POST",
                                                                  headers: {
                                                                    "Content-Type":
                                                                      "application/json"
                                                                  },
                                                                  body: JSON.stringify(
                                                                    payload
                                                                  )
                                                                }
                                                              )
                                                                .then(
                                                                  async res => {
                                                                    const data =
                                                                      await res
                                                                        .json()
                                                                        .catch(
                                                                          () =>
                                                                            null
                                                                        );
                                                                    if (
                                                                      !res.ok
                                                                    ) {
                                                                      console.error(
                                                                        `❌ Server error (${res.status}):`,
                                                                        data ||
                                                                          res.statusText
                                                                      );
                                                                      return;
                                                                    } else {
                                                                      emailInput.value =
                                                                        "";
                                                                      nameInput.value =
                                                                        "";
                                                                      messageInput.value =
                                                                        "";
                                                                      email =
                                                                        "";
                                                                      payload.name =
                                                                        "";
                                                                      payload.message =
                                                                        "";
                                                                      payload.email =
                                                                        "";
                                                                      console.log(
                                                                        "payload: ",
                                                                        payload.name
                                                                      );
                                                                      setTimeout(
                                                                        () => {
                                                                          nameInput.value =
                                                                            "";
                                                                          messageInput.value =
                                                                            "";
                                                                          emailInput.value =
                                                                            "";
                                                                        },
                                                                        0
                                                                      );
                                                                    }
                                                                    console.log(
                                                                      "\u2705 Response from backend:",
                                                                      data
                                                                    );
                                                                  }
                                                                )
                                                                .catch(err => {
                                                                  console.error(
                                                                    "\uD83D\uDEA8 Network or fetch error:",
                                                                    err
                                                                  );
                                                                });
                                                            }
                                                          })();
                                                        }
                                                    };
                                                    return (({
                                                      customFunction
                                                    }) => {
                                                      return customFunction();
                                                    })?.apply(null, [
                                                      actionArgs
                                                    ]);
                                                  })()
                                                : undefined;
                                              if (
                                                $steps["backend"] != null &&
                                                typeof $steps["backend"] ===
                                                  "object" &&
                                                typeof $steps["backend"]
                                                  .then === "function"
                                              ) {
                                                $steps["backend"] =
                                                  await $steps["backend"];
                                              }
                                            }}
                                            platform={"react"}
                                          >
                                            {"send"}
                                          </PlasmicLink__>
                                        }
                                        <React.Fragment>{" ]"}</React.Fragment>
                                      </React.Fragment>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                            helperText={(() => {
                              try {
                                return $state.helperText;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return undefined;
                                }
                                throw e;
                              }
                            })()}
                            label={``}
                            showFormElement={true}
                            showHelperText={(() => {
                              try {
                                return $state.helperTextOn;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return false;
                                }
                                throw e;
                              }
                            })()}
                            status={(() => {
                              try {
                                return $state.showErrorMode;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return "normal";
                                }
                                throw e;
                              }
                            })()}
                          />
                        }
                        layout={"oneBox"}
                      />
                    }
                  />
                </ContainerInTab>
              }
              tabDock={
                <WebDock
                  data-plasmic-name={"webDock"}
                  data-plasmic-override={overrides.webDock}
                  className={classNames("__wab_instance", sty.webDock)}
                  modulesWrapper={
                    <React.Fragment>
                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__nlMr8
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__acewn
                            )}
                          >
                            <Icon30Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__aSdPm
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebHomepage"] = true
                            ? (() => {
                                const actionArgs = { destination: `/` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebHomepage"] != null &&
                            typeof $steps["goToWebHomepage"] === "object" &&
                            typeof $steps["goToWebHomepage"].then === "function"
                          ) {
                            $steps["goToWebHomepage"] =
                              await $steps["goToWebHomepage"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__i7IBk
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__exPqR
                            )}
                          >
                            <Icon23Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__aHz4K
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebRoadmap"] = true
                            ? (() => {
                                const actionArgs = { destination: `/roadmap` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebRoadmap"] != null &&
                            typeof $steps["goToWebRoadmap"] === "object" &&
                            typeof $steps["goToWebRoadmap"].then === "function"
                          ) {
                            $steps["goToWebRoadmap"] =
                              await $steps["goToWebRoadmap"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__gsG4G
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__jcVs
                            )}
                          >
                            <Icon34Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__fa64H
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebTheIndependent"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/the-independent`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebTheIndependent"] != null &&
                            typeof $steps["goToWebTheIndependent"] ===
                              "object" &&
                            typeof $steps["goToWebTheIndependent"].then ===
                              "function"
                          ) {
                            $steps["goToWebTheIndependent"] =
                              await $steps["goToWebTheIndependent"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__u1ZuR
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__m57EM
                            )}
                          >
                            <Icon32Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__rEcUi
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebDemo"] = true
                            ? (() => {
                                const actionArgs = { destination: `/demo` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebDemo"] != null &&
                            typeof $steps["goToWebDemo"] === "object" &&
                            typeof $steps["goToWebDemo"].then === "function"
                          ) {
                            $steps["goToWebDemo"] = await $steps["goToWebDemo"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__old5E
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__nNy
                            )}
                          >
                            <Icon33Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg___4JgrM
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebFiles"] = true
                            ? (() => {
                                const actionArgs = { destination: `/files` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebFiles"] != null &&
                            typeof $steps["goToWebFiles"] === "object" &&
                            typeof $steps["goToWebFiles"].then === "function"
                          ) {
                            $steps["goToWebFiles"] =
                              await $steps["goToWebFiles"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock___9Hz3Y
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__evZ1Q
                            )}
                          >
                            <Icon15Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg___7JgCu
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebWorkspace"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/workspace`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebWorkspace"] != null &&
                            typeof $steps["goToWebWorkspace"] === "object" &&
                            typeof $steps["goToWebWorkspace"].then ===
                              "function"
                          ) {
                            $steps["goToWebWorkspace"] =
                              await $steps["goToWebWorkspace"];
                          }
                        }}
                        status={"selected"}
                      />

                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__jxbU
                        )}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__xBe8X
                          )}
                        />
                      </div>
                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__ovcQv
                        )}
                        color={"dark"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox___1L0Rb
                            )}
                          >
                            <Icon27Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__n2TgS
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebGallery"] = true
                            ? (() => {
                                const actionArgs = { destination: `/gallery` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebGallery"] != null &&
                            typeof $steps["goToWebGallery"] === "object" &&
                            typeof $steps["goToWebGallery"].then === "function"
                          ) {
                            $steps["goToWebGallery"] =
                              await $steps["goToWebGallery"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__pmhVi
                        )}
                        color={"dark"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__a48UW
                            )}
                          >
                            <Icon26Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg___0Ctxf
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebPartnersCommunity"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/partners-community`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebPartnersCommunity"] != null &&
                            typeof $steps["goToWebPartnersCommunity"] ===
                              "object" &&
                            typeof $steps["goToWebPartnersCommunity"].then ===
                              "function"
                          ) {
                            $steps["goToWebPartnersCommunity"] =
                              await $steps["goToWebPartnersCommunity"];
                          }
                        }}
                        status={"_default"}
                      />
                    </React.Fragment>
                  }
                />
              }
              tabNav={
                <WebTopNav
                  data-plasmic-name={"webTopNav"}
                  data-plasmic-override={overrides.webTopNav}
                  className={classNames("__wab_instance", sty.webTopNav)}
                  pageButtons={
                    <React.Fragment>
                      <div
                        data-plasmic-name={"pageActionsWrapper"}
                        data-plasmic-override={overrides.pageActionsWrapper}
                        className={classNames(
                          projectcss.all,
                          sty.pageActionsWrapper
                        )}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__qSbiR
                          )}
                        >
                          <React.Fragment>
                            <React.Fragment>{"[ "}</React.Fragment>
                            {
                              <PlasmicLink__
                                className={classNames(
                                  projectcss.all,
                                  projectcss.a,
                                  projectcss.a__fRuRb,
                                  projectcss.__wab_text,
                                  projectcss.plasmic_default__inline,
                                  sty.link__xiqe1
                                )}
                                href={`/signup`}
                                platform={"react"}
                              >
                                {"sign up free"}
                              </PlasmicLink__>
                            }
                            <React.Fragment>
                              {
                                " ] for live conversation or email us directly at team@o21p.com"
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </div>
                      </div>
                      <ButtonSecondary
                        data-plasmic-name={"buttonSecondary"}
                        data-plasmic-override={overrides.buttonSecondary}
                        className={classNames(
                          "__wab_instance",
                          sty.buttonSecondary
                        )}
                        color={"primary"}
                        content={"x"}
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebWorkspace"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/workspace`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebWorkspace"] != null &&
                            typeof $steps["goToWebWorkspace"] === "object" &&
                            typeof $steps["goToWebWorkspace"].then ===
                              "function"
                          ) {
                            $steps["goToWebWorkspace"] =
                              await $steps["goToWebWorkspace"];
                          }
                        }}
                      />
                    </React.Fragment>
                  }
                  pageTitle={
                    <Breadcrumb
                      data-plasmic-name={"breadcrumb"}
                      data-plasmic-override={overrides.breadcrumb}
                      className={classNames("__wab_instance", sty.breadcrumb)}
                      crumbCount={"justTitle"}
                      sidePadding={"_default"}
                      size={"navS"}
                      tabTitle={"o21p support."}
                    />
                  }
                />
              }
            />
          }
          className={classNames("__wab_instance", sty.appShell)}
          layoutType={"_default"}
        />
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "appShell",
    "webTab",
    "webTopNav",
    "breadcrumb",
    "pageActionsWrapper",
    "buttonSecondary",
    "containerInTab",
    "webSupportContainer",
    "inputFormShell",
    "formElement",
    "supportFormWrapper",
    "floatyWrapper5",
    "inlineTextWrapp6",
    "textareaWrapp2",
    "floatyWrapper6",
    "inlineTextWrapp7",
    "inlineTextWrapp8",
    "webDock"
  ],

  appShell: [
    "appShell",
    "webTab",
    "webTopNav",
    "breadcrumb",
    "pageActionsWrapper",
    "buttonSecondary",
    "containerInTab",
    "webSupportContainer",
    "inputFormShell",
    "formElement",
    "supportFormWrapper",
    "floatyWrapper5",
    "inlineTextWrapp6",
    "textareaWrapp2",
    "floatyWrapper6",
    "inlineTextWrapp7",
    "inlineTextWrapp8",
    "webDock"
  ],

  webTab: [
    "webTab",
    "webTopNav",
    "breadcrumb",
    "pageActionsWrapper",
    "buttonSecondary",
    "containerInTab",
    "webSupportContainer",
    "inputFormShell",
    "formElement",
    "supportFormWrapper",
    "floatyWrapper5",
    "inlineTextWrapp6",
    "textareaWrapp2",
    "floatyWrapper6",
    "inlineTextWrapp7",
    "inlineTextWrapp8",
    "webDock"
  ],

  webTopNav: [
    "webTopNav",
    "breadcrumb",
    "pageActionsWrapper",
    "buttonSecondary"
  ],

  breadcrumb: ["breadcrumb"],
  pageActionsWrapper: ["pageActionsWrapper"],
  buttonSecondary: ["buttonSecondary"],
  containerInTab: [
    "containerInTab",
    "webSupportContainer",
    "inputFormShell",
    "formElement",
    "supportFormWrapper",
    "floatyWrapper5",
    "inlineTextWrapp6",
    "textareaWrapp2",
    "floatyWrapper6",
    "inlineTextWrapp7",
    "inlineTextWrapp8"
  ],

  webSupportContainer: [
    "webSupportContainer",
    "inputFormShell",
    "formElement",
    "supportFormWrapper",
    "floatyWrapper5",
    "inlineTextWrapp6",
    "textareaWrapp2",
    "floatyWrapper6",
    "inlineTextWrapp7",
    "inlineTextWrapp8"
  ],

  inputFormShell: [
    "inputFormShell",
    "formElement",
    "supportFormWrapper",
    "floatyWrapper5",
    "inlineTextWrapp6",
    "textareaWrapp2",
    "floatyWrapper6",
    "inlineTextWrapp7",
    "inlineTextWrapp8"
  ],

  formElement: [
    "formElement",
    "supportFormWrapper",
    "floatyWrapper5",
    "inlineTextWrapp6",
    "textareaWrapp2",
    "floatyWrapper6",
    "inlineTextWrapp7",
    "inlineTextWrapp8"
  ],

  supportFormWrapper: [
    "supportFormWrapper",
    "floatyWrapper5",
    "inlineTextWrapp6",
    "textareaWrapp2",
    "floatyWrapper6",
    "inlineTextWrapp7",
    "inlineTextWrapp8"
  ],

  floatyWrapper5: ["floatyWrapper5", "inlineTextWrapp6"],
  inlineTextWrapp6: ["inlineTextWrapp6"],
  textareaWrapp2: ["textareaWrapp2"],
  floatyWrapper6: ["floatyWrapper6", "inlineTextWrapp7", "inlineTextWrapp8"],
  inlineTextWrapp7: ["inlineTextWrapp7"],
  inlineTextWrapp8: ["inlineTextWrapp8"],
  webDock: ["webDock"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebSupport__ArgProps,
          internalVariantPropNames: PlasmicWebSupport__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebSupport__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicWebSupport";
  } else {
    func.displayName = `PlasmicWebSupport.${nodeName}`;
  }
  return func;
}

function withUsePlasmicAuth(WrappedComponent) {
  const WithUsePlasmicAuthComponent = props => {
    const dataSourceCtx = usePlasmicDataSourceContext() ?? {};
    const { isUserLoading, user, token } = plasmicAuth.usePlasmicAuth({
      appId: "fRuRbcdHVNMtdcnFK96ivt"
    });
    return (
      <PlasmicDataSourceContextProvider__
        value={{
          ...dataSourceCtx,
          isUserLoading,
          userAuthToken: token,
          user
        }}
      >
        <WrappedComponent {...props} />
      </PlasmicDataSourceContextProvider__>
    );
  };
  return WithUsePlasmicAuthComponent;
}

export const PlasmicWebSupport = Object.assign(
  // Top-level PlasmicWebSupport renders the root element
  withUsePlasmicAuth(makeNodeComponent("root")),
  {
    // Helper components rendering sub-elements
    appShell: makeNodeComponent("appShell"),
    webTab: makeNodeComponent("webTab"),
    webTopNav: makeNodeComponent("webTopNav"),
    breadcrumb: makeNodeComponent("breadcrumb"),
    pageActionsWrapper: makeNodeComponent("pageActionsWrapper"),
    buttonSecondary: makeNodeComponent("buttonSecondary"),
    containerInTab: makeNodeComponent("containerInTab"),
    webSupportContainer: makeNodeComponent("webSupportContainer"),
    inputFormShell: makeNodeComponent("inputFormShell"),
    formElement: makeNodeComponent("formElement"),
    supportFormWrapper: makeNodeComponent("supportFormWrapper"),
    floatyWrapper5: makeNodeComponent("floatyWrapper5"),
    inlineTextWrapp6: makeNodeComponent("inlineTextWrapp6"),
    textareaWrapp2: makeNodeComponent("textareaWrapp2"),
    floatyWrapper6: makeNodeComponent("floatyWrapper6"),
    inlineTextWrapp7: makeNodeComponent("inlineTextWrapp7"),
    inlineTextWrapp8: makeNodeComponent("inlineTextWrapp8"),
    webDock: makeNodeComponent("webDock"),
    // Metadata about props expected for PlasmicWebSupport
    internalVariantProps: PlasmicWebSupport__VariantProps,
    internalArgProps: PlasmicWebSupport__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/support",
      pagePath: "/support",
      params: {},
      query: {}
    })
  }
);

export default PlasmicWebSupport;
/* prettier-ignore-end */
